export default function WhyUXOHire({ user, navigate }) {
  const techBenefits = [
    "🎯 Get discovered by UXO companies actively hiring in your area and nationwide",
    "📋 Track your certifications and get alerts before they expire — never miss a renewal",
    "📈 Log your field hours and track your career progression toward your next qualification level",
    "✓ Submit your signed logbook and earn a Hours Documented badge that shows employers your credentials are on file",
    "🔒 Your contact info stays private until an employer unlocks your profile — you stay in control",
  ];

  const employerBenefits = [
    "🔍 Browse UXO technicians with documented certifications, field hours, and logbooks on file",
    "🎯 See exactly how each tech matches your job requirements before spending an unlock",
    "📄 Access resumes, certifications, and logbooks all in one place after unlocking a profile",
    "⚡ Post jobs and get applications from qualified techs — not random resumes from generic job boards",
    "🏆 Stop relying on word of mouth — build a talent pipeline with credentials on record",
  ];

  return (
    <section style={sectionStyle} data-why-section>
      <h2 style={titleStyle}>Why UXOHire?</h2>
      <p style={subtitleStyle}>
        The specialized platform connecting certified UXO professionals with the companies that need them.
        Built for UXO technicians at every stage — from UXO school graduates and those transitioning out of
        military EOD to senior supervisors with decades in the field.
      </p>
      <div style={columnsStyle} data-why-columns>
        {/* Left — Technicians */}
        <div style={cardStyle} data-why-card>
          <h3 style={headerStyle}>Built for UXO Professionals</h3>
          <p style={subheaderStyle}>Free to join.</p>
          <ul style={listStyle}>
            {techBenefits.map((b, i) => (
              <li key={i} style={itemStyle}>{b}</li>
            ))}
          </ul>
          {!user && (
            <button
              style={ctaStyle}
              onClick={() => navigate('/signup', { state: { accountType: 'technician' } })}
            >
              Create Free Tech Profile
            </button>
          )}
        </div>

        {/* Right — Employers */}
        <div style={cardStyle} data-why-card>
          <h3 style={headerStyle}>Hire Faster. Hire Smarter.</h3>
          <p style={subheaderStyle}>The only job board built exclusively for the UXO industry.</p>
          <ul style={listStyle}>
            {employerBenefits.map((b, i) => (
              <li key={i} style={itemStyle}>{b}</li>
            ))}
          </ul>
          {!user && (
            <button
              style={ctaStyle}
              onClick={() => navigate('/signup', { state: { accountType: 'employer' } })}
            >
              Post Your First Job
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

const sectionStyle = {
  background: "#0a0b0c",
  borderTop: "1px solid #1e2022",
  borderBottom: "1px solid #1e2022",
  padding: "64px 0",
  marginTop: 48,
};

const titleStyle = {
  fontSize: 36,
  fontWeight: "bold",
  color: "#d97706",
  textAlign: "center",
  margin: "0 0 12px",
  letterSpacing: "-0.5px",
};

const subtitleStyle = {
  fontSize: 16,
  color: "#9a9490",
  textAlign: "center",
  maxWidth: 560,
  margin: "0 auto 40px",
  lineHeight: 1.6,
};

const columnsStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 24,
  maxWidth: 1100,
  margin: "0 auto",
  padding: "0 24px",
  boxSizing: "border-box",
};

const cardStyle = {
  background: "#111316",
  border: "1px solid #1e2022",
  borderRadius: 12,
  padding: "32px 28px",
};

const headerStyle = {
  fontSize: 22,
  fontWeight: "bold",
  color: "#d97706",
  margin: "0 0 6px",
};

const subheaderStyle = {
  fontSize: 14,
  color: "#9a9490",
  margin: "0 0 20px",
  lineHeight: 1.5,
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: "0 0 24px",
  display: "flex",
  flexDirection: "column",
  gap: 14,
};

const itemStyle = {
  fontSize: 14,
  color: "#c8c4bc",
  lineHeight: 1.6,
};

const ctaStyle = {
  background: "#d97706",
  border: "none",
  color: "#0d0f10",
  padding: "12px 24px",
  fontSize: 15,
  fontWeight: "bold",
  borderRadius: 6,
  cursor: "pointer",
  fontFamily: "inherit",
  width: "100%",
};
